import { FC } from 'react';

import { GridLayout, VSpacing } from '@hh.ru/magritte-ui';

import { AdminHeader } from 'components/Admin/AdminHeader/AdminHeader';
import { BannerModerationInfo } from 'components/Admin/BannerModerationInfo/BannerModerationInfo';
import Nav from 'components/Admin/Nav/Nav';

export const BannerModerationInfoPage: FC = () => (
    <>
        <AdminHeader />
        <GridLayout>
            <VSpacing default={24} />
            <Nav />
            <BannerModerationInfo />
        </GridLayout>
    </>
);
